

import React from 'react';
import Hero from '../components/Hero';
import JoinSection from '../components/Join';
import Footer from '../components/Footer'


const Home = () => {
 

    return (
        <div className="banner-section">
            <Hero />
            <JoinSection />
            <Footer/>
           
        </div>
    );
};

export default Home;






